import { BarChart3, FileText, Flame, Users } from 'lucide-react';
import { AppShellPanel } from '@/components/ui/AppShellPanel';
import { seedNews } from '@/data/seedNews';

const metrics = [
  { label: 'Publicadas', value: seedNews.length, icon: FileText },
  { label: 'Ultimo momento', value: seedNews.filter((item) => item.breaking).length, icon: Flame },
  { label: 'Lectores activos', value: 128, icon: Users },
  { label: 'Lectura media', value: '2m', icon: BarChart3 }
];

export function AdminDashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-black">Dashboard</h1>
        <p className="mt-1 text-white/60">Operacion editorial, rendimiento y publicacion.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {metrics.map(({ label, value, icon: Icon }) => (
          <AppShellPanel key={label}>
            <Icon className="text-divergent-yellow" size={22} aria-hidden="true" />
            <div className="mt-4 text-3xl font-black">{value}</div>
            <div className="text-sm text-white/60">{label}</div>
          </AppShellPanel>
        ))}
      </div>
      <AppShellPanel>
        <h2 className="font-semibold">Noticias recientes</h2>
        <div className="mt-4 divide-y divide-white/10">
          {seedNews.map((article) => (
            <div key={article.id} className="flex items-center justify-between gap-4 py-3">
              <div>
                <div className="font-semibold">{article.title}</div>
                <div className="text-sm text-white/55">{article.category}</div>
              </div>
              <span className="rounded bg-white/10 px-2 py-1 text-xs">{article.status}</span>
            </div>
          ))}
        </div>
      </AppShellPanel>
    </div>
  );
}
